<template>
  <page>
    <message :messages="messages"></message>
    <v-container fluid grid-list-md>
      <v-layout row>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Report Type
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs6>
                        <v-select v-model="form.rptType" :label="labels.rptType" :items="reportTypeList" item-text="label" item-value="value" />
                      </v-flex>
                      <v-flex xs6></v-flex>
                      <v-flex xs6>
                        <v-select v-model="form.dateType" :items="DateList" :label="labels.dateType" item-text="label" item-value="value" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                          :error-messages="errors.collect('form.tranDateFrom')" v-validate="'required'" />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                          :error-messages="errors.collect('form.tranDateTo')" v-validate="'required'" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel4"  multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Selection Criteria
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.inter" :label="labels.inter" :error-messages="errors.collect('inter')"
                        :data-vv-as="labels.inter" data-vv-name="inter" append-icon="mdi-magnify" @click:append="multiInterList = true" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.insdRef" :label="labels.insdRef" :error-messages="errors.collect('insdRef')" data-vv-name="insdRef" :data-vv-as="labels.insdRef" append-icon="mdi-magnify" @click:append="insdFilter = true" readonly></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
              data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

      <!-- Billing Account Helplist -->
      <v-dialog v-model="multiInterList" width="900px" persistent>
        <multi-intermediary-help-list
          :intr="form.inter"
          :intrGrp="intrGrp"
          :listName="'billAcctNoList'"
          helpListTitle="Billing Account Helplist"
          @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
      </v-dialog>
      <v-dialog v-model="insdFilter" width="1280px" persistent>
          <insured-filter :menu="menu" @close="doClose" @doAssign="doAssignInsdRef($event)"></insured-filter>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import InsuredFilter from './InsuredFilter.vue'

export default {
  mixins: [
    MessageMixin
  ],
  components: {
    MultiIntermediaryHelpList,
    InsuredFilter
  },
  data() {
    return {
      menu: {},
      multiInterList: false,
      insdFilter: false,
      submitting: false,
      intrGrp: 'clmListByAgentOrAcct',
      showErrorDialog: false,
      supportedFormat: [],
      form: {
        rptType: 'AG',
        dateType: 'LD',
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        pbPrtParam: true,
        format: 'XLSX',
        inter: 'All',
        insdRef: 'All'
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        dateType: 'Date By',
        rptType: 'Report By',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO',
        inter: 'Agent',
        insdRef: 'Insured'
      },
      reportTypeList: [
        { label: 'Agent', value: 'AG' },
        { label: 'Insured', value: 'AC' }
      ],
      DateList: [
        { label: 'Loss Date', value: 'LD' },
        { label: 'Claim Created Date', value: 'CCD' }
      ],
      panel1: [0],
      panel2: [0],
      panel3: [0],
      panel4: [0],
      panel5: [0]
    }
  },
  mounted() {
    this.doInit()
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    supportedList() {
      const result = []
      // result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    },
    years() {
      const tempYearList = []
      const year = new Date().getFullYear()
      tempYearList.push(0)
      for (var i = 1999; i <= year; i++) {
        tempYearList.push(i)
      }
      return tempYearList
    },
    doValidateToLossYear() {
      if (this.form.lossYearFrom !== 0) {
        return '|valMaxLossYear:' + this.form.lossYearFrom
      } else {
        return ''
      }
    },
    doValidateToUWYear() {
      if (this.form.uwYearFrm !== 0) {
        return '|valMaxUWYear:' + this.form.uwYearFrm
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmListByAgentOrAcct
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          await this.$http.post(apiURI, this.form)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.showErrorDialog = true
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.multiInterList = false
      this.insdFilter = false
    },
    doAssignInter(Obj) {
      this.form.inter = []
      this.form.inter = Obj.finalSelectedItems.toString()
    },
    doAssignInsdRef(Obj) {
      this.form.insdRef = []
      this.form.insdRef = Obj.finalSelectedItems.toString()
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
  }
}
</script>
